module.exports = __webpack_public_path__ + "img/Michal Zawada.75bb037a.webp";